import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useInfiniteQuery } from '@tanstack/react-query';
import { OrdersApiAdapter } from '../adapters/OrdersApiAdapter';
import { Filters } from '../models/Orders';
import { Service } from '../services/Service';

export const useOrders = (filters: Filters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new OrdersApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['orders', filters],
    queryFn: ({ pageParam = 1 }) =>
      service.getPaginated({
        ...filters,
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    placeholderData: (previousData) => previousData,
    staleTime: 2 * 60 * 1000, // 2 minutos
    gcTime: 5 * 60 * 1000, // 5 minutos
  });

  const orders = data?.pages.flatMap((page) => page.orders) ?? [];

  // Obtener el total del API (siempre sera el mismo en todas las paginas)
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    orders,
    isLoading: isLoading || isPending,
    isFetching, // 🎯 Necesario para aplicar opacidad durante refetch
    error,
    refetch,
    // Nuevas props para scroll infinito
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    // Stats útiles
    totalPages: data?.pages.length ?? 0,
    totalLocations: orders.length,
    total: totalFromApi, // Total real del API
  };
};
